import RequireAuthentication from '@/router/guards/RequireAuthentication'
import { lazy } from 'react'

const WelcomeYourHealth = lazy(() => import('./pages/WelcomeYourHealth'))

const HealthData = lazy(() => import('./pages/HealthData'))

const HealthDataDetails = lazy(() => import('./pages/HealthDataDetails'))

const TypeOfService = lazy(() => import('./pages/TypeOfService'))

const QuestionaryStart = lazy(() => import('./pages/QuestionaryStart'))

const Questionary = lazy(() => import('./pages/QuestionaryMentalHealth'))

const QuestionaryResult = lazy(() => import('./pages/QuestionaryResult'))

const MentalHealth = lazy(() => import('./pages/MentalHealth'))

const YourHealthRoutes = [
  <RequireAuthentication
    path="/sua-saude/bem-vindo"
    key="/sua-saude/bem-vindo"
    exact
    component={WelcomeYourHealth}
  />,
  <RequireAuthentication
    path="/sua-saude"
    key="/sua-saude"
    exact
    component={HealthData}
  />,
  <RequireAuthentication
    path="/sua-saude/dados-de-saude/detalhes"
    key="/sua-saude/dados-de-saude/detalhes"
    exact
    component={HealthDataDetails}
  />,
  <RequireAuthentication
    path="/agendamento/:prevPath?/tipo-de-atendimento"
    key="/agendamento/tipo-de-atendimento"
    exact
    component={TypeOfService}
  />,
  <RequireAuthentication
    path="/sua-saude/quiz/iniciar"
    key="/sua-saude/quiz/iniciar"
    exact
    component={QuestionaryStart}
  />,
  <RequireAuthentication
    path="/sua-saude/quiz/responder"
    key="/sua-saude/quiz/responder"
    exact
    component={Questionary}
  />,
  <RequireAuthentication
    path="/sua-saude/quiz/resultado"
    key="/sua-saude/quiz/resultado"
    exact
    component={QuestionaryResult}
  />,
  <RequireAuthentication
    path="/sua-saude/saude-mental"
    key="/sua-saude/saude-mental"
    exact
    component={MentalHealth}
  />,
]

export default YourHealthRoutes
